'use client';

import React, { memo, useEffect, useState } from 'react';
import { MODALS } from '../../../util/constants';
import getStrapiModalInfo from '../../../util/getStrapiModalInfo';
import SweeprActionModal from '../../shared/sweepr-action-modal/SweeprActionModal';

const { EIR_SUPPORT } = MODALS;

/**
 * @name EirSupportModal
 * @description - Mobile Support Modal component
 * @param {boolean} showEirSupportModal - Toggle's the mobile support redirect modal
 * @returns {JSX.Element} Account Verification Modal
 */
const EirSupportModal = ({ showEirSupportModal, handleAction }) => {
  const [cmsData, setCmsData] = useState(null);
  const [load, setLoad] = useState(true);

  /**
   * @name getCmsData
   * @description Fetches data from the Strapi API
   * @returns {Promise<void>} Promise and sets the state cmsData when resolved
   */
  const getCmsData = async () => {
    const data = await getStrapiModalInfo(EIR_SUPPORT);
    setCmsData(data);
  };

  useEffect(() => {
    setLoad(false);
    getCmsData();
  }, []);

  return (
    <SweeprActionModal
      id={cmsData?.attributes?.modalID}
      open={showEirSupportModal?.value}
      handleClose={showEirSupportModal?.disable}
      handleBack={showEirSupportModal?.disable}
      title={cmsData?.attributes?.title}
      iconSrc={cmsData?.attributes?.iconSrc?.data?.attributes?.url}
      description={cmsData?.attributes?.firstHalfDescription}
      cta={cmsData?.attributes?.cta}
      load={load}
      handleAction={handleAction}
      disableCloseOnBackdropClick
      disableCloseOnEscapeKeyDown
    />
  );
};

EirSupportModal.displayName = 'EirSupportModal';
export default memo(EirSupportModal);
